import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Cookie, X } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'nt2_cookie_consent';

export const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label="Cookie-toestemming"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-2xl"
    >
      <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 sm:py-5">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Icon + text */}
          <div className="flex items-start gap-3 flex-1">
            <Cookie className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" />
            <p className="text-sm text-gray-700 leading-relaxed">
              {t('cookieBanner.text')}{' '}
              <strong>{t('cookieBanner.accept')}</strong>{' '}
              {t('cookieBanner.agreeWith')}{' '}
              <a href="/cookies" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:no-underline">
                {t('cookieBanner.cookiePolicy')}
              </a>
              {' '}{t('cookieBanner.and')}{' '}
              <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:no-underline">
                {t('cookieBanner.privacyPolicy')}
              </a>
              .
            </p>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={decline}
              className="text-sm text-gray-600 border border-gray-300 rounded-lg px-4 py-2 hover:bg-gray-50 transition-colors"
            >
              {t('cookieBanner.decline')}
            </button>
            <button
              onClick={accept}
              className="text-sm bg-primary text-white rounded-lg px-5 py-2 hover:bg-primary/90 transition-colors font-medium"
            >
              {t('cookieBanner.accept')}
            </button>
            <button
              onClick={decline}
              aria-label={t('cookieBanner.closeAria')}
              className="text-gray-400 hover:text-gray-600 transition-colors ml-1"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
